import logo from './logo.svg';
import './App.css';

import Join from './components/join';
import Fans from './components/fans';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import Home from './components/home';
import About from './components/about';


// import music from './music/The-Princess.mp3'
// import MusicPlayer from './components/music-player';

import { useEffect, useState, useCallback, useRef } from 'react';
import { database } from "./firebaseConfig2";
import { collection, doc, setDoc, onSnapshot  } from "firebase/firestore"; 
import Buttons from './components/buttons';
// import Chatroom from './components/chatroom';
import Stp from './components/stp';
import BgImage from './components/bg-image';
import MotionBtn from './components/motion_btn';



function App() {

  const mediaQuery = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  );

  console.log(mediaQuery);
  console.log(mediaQuery.matches);
  
  const [width, setWidth] = useState(window.innerWidth) //width of viewport

  const [isLoading, setIsLoading] = useState(true);

  const [fansList, setFansList] = useState([]);
  const [numCountries, setNumCountries] = useState(0);
  const [numFans, setNumFans] = useState(0);
  const [isMoving, setIsMoving] = useState(false);
  const [isMovementOn, setIsMovementOn] = useState(!(mediaQuery.matches));

  const childRef = useRef(); //for triggering child function

  const handleMouseMove = (event) => {
      if (isMovementOn){
        childRef.current.handleMouseMove2(event);
      }
    };


  window.addEventListener('resize', function(event){
        setWidth(window.innerWidth);
        if (width < 1000){
          setIsMovementOn(false); //disable animations on a tiny screen
        }
    });

  //pull list of fans from firebase
  useEffect(
    () =>
      onSnapshot(collection(database, "stp_fans"), (snapshot) => {
        snapshot.forEach((doc) => {
          let tempfan = {
            country: doc.data().country,
            email: doc.data().email,
            name: doc.data().name,
            website: doc.data().website,
            princess: doc.data().princess
          }
          setFansList(fansList => [...fansList, tempfan]);
          setIsLoading(false);

          
        });

        }),
    []
  );
  


  return (
    <BrowserRouter>
      <div className='site-wrapper' onMouseMove={handleMouseMove}>
      <BgImage ref={childRef}/>
      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home fansList={fansList} numCountries={numCountries} numFans={numFans} set={numFans}/>} />
        <Route path="/join" element={<Join />} />
        <Route path="/fans" element={<Fans fansList={fansList} numCountries={numCountries} setNumCountries={setNumCountries}  numFans={numFans} set={numFans}/>} />
        <Route path="/codes" element={<Buttons/>} />
        <Route path="/about" element={<About fansList={fansList} numCountries={numCountries} setNumCountries={setNumCountries}  numFans={numFans} set={numFans}/>} />
        <Route path="/stp" element={<Stp fansList={fansList} numCountries={numCountries} setNumCountries={setNumCountries}  numFans={numFans} set={numFans}/>} />
        {/* <Route path="/chatroom" element={<Chatroom fansList={fansList} numCountries={numCountries} setNumCountries={setNumCountries}  numFans={numFans} set={numFans}/>} /> */}


        {/* <Route path="/contact" element={<Contact />} /> */}
      </Routes>
            <MotionBtn isMovementOn={isMovementOn} setIsMovementOn={setIsMovementOn} width={width}/>
            <div className='link-menu-bg'></div>
            <div className={width <= 900 ? "link-menu-mobile" : "link-menu"}>
                  <Link to="/"><span className='bullet'>• </span>Home</Link>
                  <Link to="/about"><span className='bullet'>• </span>About the fanlisting</Link>
                  <Link to="/stp"><span className='bullet'>• </span>About the game</Link>
                  <Link to="/fans"><span className='bullet'>• </span>Fans</Link>
                  <Link to="/join"><span className='bullet'>• </span>Join</Link>
                  <Link to="/codes"><span className='bullet'>• </span>Codes</Link>
                  {/* <Link onClick={() => handleNavigation("chatroom") } to="/chatroom">• Chatroom</Link> */}

            </div>
            {/* <MusicPlayer audio={audio}/> */}
        </div>
    </BrowserRouter>
  );
}
//DejaVu sans = names
//questions, titles, "this is a love story" = kelmscott roman nf
//princess Amatic SC
//long quiet/evil princess = East Sea Dokdo
export default App;
